export default __webpack_public_path__ + "static/media/(83).ce57e90c.jpg";